(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosSectorSfaNewController", LebaniegoYearContactosSectorSfaNewController);

    LebaniegoYearContactosSectorSfaNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearContactosSectorSfa",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearContactosSectorSfaNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearContactosSectorSfa,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorSfa = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorSfa = Object.assign({}, vm.lebaniegoYearContactosSectorSfa);
            lebaniegoYearContactosSectorSfa.id = null;
            lebaniegoYearContactosSectorSfa.sector = "Sector fabricantes de aceite";
            LebaniegoYearContactosSectorSfa.save(lebaniegoYearContactosSectorSfa, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-contacts-sector-sfa", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el acta");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();